export default {
  props: {
    projectMetric: { type: Object, default: null }
  },
  methods: {
    getTitle(name, defaultTitle) {
      if (this.include.length === 0) {
        return defaultTitle || this.$formatter.capitalize(name);
      }

      let entry = this.renames.find(r => r.old === name);
      return entry != null ? entry.new  : (defaultTitle || this.$formatter.capitalize(name));
    },
    isIncluded(name, fields) {
      return (this.include.length === 0 || this.include.includes(name)) &&
        (fields == null || fields.length === 0 || fields.includes(name));
    }
  },
  computed: {
    template() {
      if (this.context == null || this.projectMetric == null) {
        return null;
      }

      let value = this.context.projectMetricTemplates.find(t => t.typeName === this.projectMetric.type);
      return value || null;
    },
    include() {
      return this.template != null ? this.template.include : [];
    },
    renames() {
      return this.template != null ? this.template.renames : [];
    }
  }
}